import * as React from "react";

interface ToggleFullscreenButtonProps {
    onToggleFullscreen: () => void,
    isShowingFullscreen: boolean
}
export class ToggleFullscreenButton extends React.Component<ToggleFullscreenButtonProps, {}>{
    render() {
        const active = this.props.isShowingFullscreen ? ' active' : '';
        const title = this.props.isShowingFullscreen ? 'Gå ut av fullskjerm-modus' : 'Vis i fullskjerm-modus';
        return (<div className={`fullscreentoggle glyphicon glyphicon-fullscreen${active}`}
                     title={title}
                     onClick={() => {this.props.onToggleFullscreen()}}/>);
    }
}
